import { Button, Card, DescriptionList } from "@swot/base-components";
import type { CmtsGridColumn, CmtsGridRowAction } from "./CmtsSmartDataGridTypes.js";

function displayValue(value: unknown): string {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  return String(value);
}

export function CmtsSmartDataGridResponsiveCard<TRecord extends Record<string, unknown>>(props: {
  record: TRecord;
  columns: readonly CmtsGridColumn<TRecord>[];
  actions: readonly CmtsGridRowAction<TRecord>[];
  onRowClick?: ((record: TRecord) => void | Promise<void>) | undefined;
  isActionDisabled?: ((action: CmtsGridRowAction<TRecord>, record: TRecord) => boolean) | undefined;
  actionDisabledReason?: ((action: CmtsGridRowAction<TRecord>, record: TRecord) => string | undefined) | undefined;
  isActionPending?: ((action: CmtsGridRowAction<TRecord>, record: TRecord) => boolean) | undefined;
  onActionClick?: ((action: CmtsGridRowAction<TRecord>, record: TRecord) => void | Promise<void>) | undefined;
}) {
  const primary = props.columns[0];
  const secondary = props.columns[1];
  const title = primary ? displayValue(primary.accessor ? primary.accessor(props.record) : props.record[primary.id]) : "Record";
  const subtitle = secondary ? displayValue(secondary.accessor ? secondary.accessor(props.record) : props.record[secondary.id]) : undefined;

  return (
    <article className="cmts-smart-grid-mobile-card" onClick={props.onRowClick ? async () => { await props.onRowClick?.(props.record); } : undefined}>
      <Card title={title} {...(subtitle ? { subtitle } : {})}>
        <DescriptionList
          items={props.columns.slice(2, 7).map((column) => ({
            label: column.header,
            value: column.render ? column.render(props.record) : displayValue(column.accessor ? column.accessor(props.record) : props.record[column.id]),
          }))}
        />
        {props.actions.length > 0 ? <footer>{props.actions.map((action) => {
          const disabled = props.isActionDisabled?.(action, props.record) ?? false;
          const pending = props.isActionPending?.(action, props.record) ?? false;
          const disabledReason = props.actionDisabledReason?.(action, props.record);
          return (
            <Button
              key={action.id}
              label={pending ? "Working..." : action.label}
              title={disabledReason ?? action.title}
              aria-label={`${action.label} ${displayValue(props.record.id)}`}
              disabled={disabled || pending}
              aria-disabled={disabled || pending}
              variant="secondary"
              onClick={async (event) => {
                event.stopPropagation();
                if (!disabled && !pending) await props.onActionClick?.(action, props.record);
              }}
            />
          );
        })}</footer> : null}
      </Card>
    </article>
  );
}
